import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig } from '@ngx-formly/core';
import { CardContentComponent } from '../../component/card-content/card-content.component';

interface InformationCardRowOptions extends FormlyFieldProps {
  cards: {
    icon?: string;
    currency?: string;
    calculation?: string;
    calculationFunction?: string;
    evaluatedCalculationFunction?: any;
    periodName?: string;
    title?: string;
    detailedCalculationFunction?: string;
    evaluatedDetailedCalculationFunction?: any;
    calculationSummaryFunction?: string;
    evaluatedCalculationSummaryFunction?: any;
    detailedCalculation?: [
      {
        label: string;
        value: number;
      },
    ];
    calculationSummary?: {
      label: string;
      value: number;
    };
  }[];
}
@Component({
  selector: 'app-information-card-row-field',
  imports: [CommonModule, CardContentComponent],
  templateUrl: './information-card-row-field.component.html',
  styleUrl: './information-card-row-field.component.scss',
})
export class InformationCardRowFieldComponent
  extends FieldType<FieldTypeConfig<InformationCardRowOptions>>
  implements OnInit
{
  override defaultOptions = {
    props: {
      cards: [],
    },
  };

  public ngOnInit(): void {
    this.props.cards.forEach(card => {
      if (card.calculationFunction) {
        card.evaluatedCalculationFunction = eval(card.calculationFunction);
      }

      if (card.calculationSummaryFunction) {
        card.evaluatedCalculationSummaryFunction = eval(
          card.calculationSummaryFunction
        );
      }

      if (card.detailedCalculationFunction) {
        card.evaluatedDetailedCalculationFunction = eval(
          card.detailedCalculationFunction
        );
      }
    });
  }
}
